import { maximumNumberValue } from '../common/number/maximum-number-value';

export const DEFAULT_MAX_WINNERS = 1;
export const DEFAULT_MAX_FINALISTS = 3;
export const COUNTRY_AWARD_MAX_WINNERS = 1;

export interface Award {
  awardId: number;
  masterAwardId: number;
  groupId: number;
  title: string;
  summary: string;
  detail: string;
  allowJointNomination: boolean;
  requireCustomerReference: boolean;
  requireWrittenNomination: boolean;
  isCountryAward: boolean;
  isRegionAward: boolean;
  judgeCapacity: number;
  maxJudgementCount: number;
  maxWinners: number;
  maxFinalists: number;
  lastUpdatedDate?: string;
  eligibilityRuleCodes: string[];
  defaultScrubbingRubric?: string;
}

export function blankAward(): Award {
  return {
    awardId: 0,
    masterAwardId: 0,
    groupId: 0,
    summary: '',
    detail: '',
    requireWrittenNomination: false,
    requireCustomerReference: false,
    allowJointNomination: false,
    title: '',
    lastUpdatedDate: undefined,
    judgeCapacity: maximumNumberValue,
    maxJudgementCount: 3,
    isCountryAward: false,
    isRegionAward: false,
    maxWinners: DEFAULT_MAX_WINNERS,
    maxFinalists: DEFAULT_MAX_FINALISTS,
    eligibilityRuleCodes: [],
    defaultScrubbingRubric: undefined,
  };
}

export function copyAward(award: Award): Award {
  const eligibilityRuleCodes: string[] = [];
  award.eligibilityRuleCodes.forEach(code => eligibilityRuleCodes.push(code));

  return {
    awardId: award.awardId,
    masterAwardId: award.masterAwardId,
    groupId: award.groupId,
    allowJointNomination: award.allowJointNomination,
    detail: award.detail,
    isCountryAward: award.isCountryAward,
    isRegionAward: award.isRegionAward,
    requireCustomerReference: award.requireCustomerReference,
    requireWrittenNomination: award.requireWrittenNomination,
    summary: award.summary,
    judgeCapacity: award.judgeCapacity,
    maxJudgementCount: award.maxJudgementCount,
    title: award.title,
    lastUpdatedDate: award.lastUpdatedDate,
    maxWinners: award.maxWinners,
    maxFinalists: award.maxFinalists,
    eligibilityRuleCodes: eligibilityRuleCodes,
    defaultScrubbingRubric: award.defaultScrubbingRubric,
  }
}

export function compareAward(awardA: Award, awardB: Award): boolean {
  const compareEligibilityRuleCodes = (): boolean => {
    if ((awardA.eligibilityRuleCodes?.length ?? 0) === 0 && (awardB.eligibilityRuleCodes?.length ?? 0) === 0) return true;
    else return (awardA.eligibilityRuleCodes?.length ?? 0) === (awardB.eligibilityRuleCodes?.length ?? 0) &&
      awardA.eligibilityRuleCodes?.every(ruleCodeA => awardB.eligibilityRuleCodes?.some(ruleCodeB => ruleCodeA === ruleCodeB));
  };

  return awardA.title === awardB.title &&
    awardA.summary === awardB.summary &&
    awardA.detail === awardB.detail &&
    awardA.allowJointNomination === awardB.allowJointNomination &&
    awardA.requireCustomerReference === awardB.requireCustomerReference &&
    awardA.requireWrittenNomination === awardB.requireWrittenNomination &&
    awardA.judgeCapacity === awardB.judgeCapacity &&
    awardA.maxWinners === awardB.maxWinners &&
    awardA.maxFinalists === awardB.maxFinalists &&
    (awardA.defaultScrubbingRubric ?? '') === (awardB.defaultScrubbingRubric ?? '') &&
    compareEligibilityRuleCodes();
}
